import * as React from 'react';

import { useIsServer } from './useIsServer';

export const useServerSidePage = (): boolean => {
  // FIXME: This is not safe for hydration, and will result in a mismatch. The
  // initial render state on the client MUST match the server.
  const isServer = useIsServer();
  const [canRender, setCanRender] = React.useState(
    typeof window !== 'undefined'
  );

  React.useEffect(() => {
    setCanRender(!isServer);
  }, [isServer]);

  return canRender;
};
